export default __webpack_public_path__ + "static/media/272.d7337a69.jpg";